module.exports = __webpack_public_path__ + "static/UserPermissions-6e21edb621d6745303a47bd9f547546b.png";